"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bresimo": {
    "c3cb40ba": [{
      "hkey": "5c3933e0",
      "slug": "fontana-nuova-bevia",
      "name": "Fontana Nuova-Bevia",
      "primary": true,
      "skipSearch": false
    }],
    "bevia": [{
      "hkey": "5c3933e0",
      "slug": "fontana-nuova-bevia",
      "name": "Fontana Nuova-Bevia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bresimo"
    }],
    "ee621194": [{
      "hkey": "efada603",
      "slug": "bresimo",
      "name": "Bresimo",
      "primary": true,
      "skipSearch": false
    }],
    "fontana": [{
      "hkey": "efada603",
      "slug": "bresimo",
      "name": "Bresimo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a2be64ba": [{
      "hkey": "5c3933e0",
      "slug": "fontana-nuova-bevia",
      "name": "Fontana Nuova-Bevia",
      "primary": true,
      "skipSearch": false
    }],
    "fontana-nuova": [{
      "hkey": "5c3933e0",
      "slug": "fontana-nuova-bevia",
      "name": "Fontana Nuova-Bevia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "bresimo"
    }]
  }
};
exports["default"] = _default;